/** UTF-8 / bytes → Base64 sicuri su Safari (niente btoa su stringhe non-Latin1). */

/** Encode solo i byte della view (mai .buffer grezzo: può essere più largo del view). */
export function bytesToBase64(bytes: Uint8Array): string {
  const copy = bytes.byteOffset === 0 && bytes.byteLength === bytes.buffer.byteLength
    ? bytes
    : new Uint8Array(bytes)
  let binary = ''
  const chunk = 0x8000
  for (let i = 0; i < copy.length; i += chunk) {
    const slice = copy.subarray(i, Math.min(i + chunk, copy.length))
    binary += String.fromCharCode.apply(null, Array.from(slice) as unknown as number[])
  }
  return btoa(binary)
}

/** JSON / testo → base64 (UTF-8 safe). */
export function utf8StringToBase64(text: string): string {
  return bytesToBase64(new TextEncoder().encode(text))
}

export function arrayBufferToBase64(buffer: ArrayBuffer): string {
  return bytesToBase64(new Uint8Array(buffer))
}

export function base64ToBytes(base64: string): Uint8Array<ArrayBuffer> {
  const binary = atob(base64.trim())
  const bytes = new Uint8Array(binary.length)
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i)
  }
  return bytes
}

export function base64ToArrayBuffer(base64: string): ArrayBuffer {
  return base64ToBytes(base64).buffer
}
